import { createContext } from 'react';
export var HeaderNavigationContext = /*#__PURE__*/createContext({
  activeMenuID: '',
  setActiveMenuID: function setActiveMenuID() {}
});